import Signup from './Signup';

export default Signup
export { Signup as Base }
